window.ShopTaxConfig = window.ShopTaxConfig || {};

(function () {
  const country = (window.Shopify && Shopify.country) || 'OTHER';
  const taxCountries = ['AT', 'DE'];
  const taxRates = { AT: 0.20, DE: 0.19 };
  const taxRate = taxRates[country];

  // --- Brutto-Berechnung als wiederverwendbare Funktion (auch für dynamische Inhalte)
  window.ShopTaxConfig.applyGrossPrices = function (root = document) {
    if (!taxCountries.includes(country)) return;

    const grossContainers = root.querySelectorAll('[data-gross-price]');
    grossContainers.forEach((container) => {
      const span = container.querySelector('.brutto-price');
      const parent = container.closest('.price');
      const nettoEl = parent?.querySelector('[data-net-price]');
      if (!span || !nettoEl) return;

      const nettoText = nettoEl.textContent.trim();
      let nettoRaw = nettoText.replace(/[^\d,.-]/g, '');
      if (nettoRaw.includes(',')) {
        nettoRaw = nettoRaw.replace(/\./g, '').replace(',', '.');
      }

      const netto = parseFloat(nettoRaw);
      if (!isNaN(netto)) {
        const brutto = (netto * (1 + taxRate)).toFixed(2).replace('.', ',');
        const newText = `(€${brutto})`;
        if (span.textContent !== newText) {
          span.textContent = newText;
        }
        container.style.display = 'block';
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    // Initial: Brutto anwenden
    window.ShopTaxConfig.applyGrossPrices(document);

    // Land anzeigen links unten (Overlay)
    const overlay = document.createElement("div");
    overlay.textContent = `Erkanntes Land: ${country}`;
    Object.assign(overlay.style, {
      position: "fixed",
      bottom: "20px",
      right: "20px",
      background: "#75A0CD",
      color: "#fff",
      padding: "10px 15px",
      borderRadius: "6px",
      zIndex: 9999,
      fontFamily: "sans-serif",
      fontSize: "14px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      transition: "opacity 1.5s ease"
    });
    document.body.appendChild(overlay);
    setTimeout(() => {
      overlay.style.opacity = "0";
      setTimeout(() => overlay.remove(), 3000);
    }, 5000);

    // Obere Leiste / Produkt-Hinweis
    console.log(Shopify.locale);

    const element = document.querySelector('.announcement__col--left');
    const shippingInfoProduct = document.querySelector('.main-product-custom-shipping-info');

    const isRequestOnly = Boolean(window.productMeta?.requestOnly);

    const t = window.themeTranslations || {};
    const TXT_EXCL_SHIPPING      = t.pricesExclShipping      || 'Preise zzgl. Versand';
    const TXT_EXCL_VAT_SHIPPING  = t.pricesExclVatShipping   || 'Preise zzgl. MwSt. und Versand';
    const TXT_REQUEST_ONLY       = t.pricesRequestOnly       || 'Preis auf Anfrage';

    // Kopfzeile IMMER (sofern Element vorhanden) – vor Doppel-Eintrag schützen
    if (element && !element.querySelector('.announcement__text--tax-note')) {
      const topBarText = taxCountries.includes(country)
        ? TXT_EXCL_SHIPPING
        : TXT_EXCL_VAT_SHIPPING;

      element.insertAdjacentHTML(
        'beforeend',
        `<div><rte></rte></div>
         <div class="announcement__text announcement__text--tax-note" style="font-weight: bold;">
           <rte>${topBarText}</rte>
         </div>`
      );
    }


    if (shippingInfoProduct && !shippingInfoProduct.querySelector('.announcement__text--tax-note')) {
      // Find the main product section/container
      const productSection = document.querySelector('.js-product');
      let price = null;
      console.log(productSection);
      if (productSection) {
        const priceEl = productSection.querySelector('[data-net-price]');
        console.log(priceEl);
        if (priceEl) {
          let priceText = priceEl.textContent.trim().replace(/[^\d,.-]/g, '');
          if (priceText.includes(',')) {
            priceText = priceText.replace(/\./g, '').replace(',', '.');
          }
          price = parseFloat(priceText);
          console.log(price);
        }
      }

      if (!price || price === 0) {
        productText = TXT_REQUEST_ONLY;
      } else {
        productText = taxCountries.includes(country) ? TXT_EXCL_SHIPPING : TXT_EXCL_VAT_SHIPPING;
      }

      shippingInfoProduct.insertAdjacentHTML(
        'beforeend',
        `<div class="announcement__text announcement__text--tax-note" style="text-align: left !important;">
          <rte>${productText}</rte>
        </div>`
      );
    }



    // --- NEU: MutationObserver für dynamisch eingefügte Inhalte (z. B. Recently viewed)
    const mo = new MutationObserver((mutations) => {
      let needsApply = false;

      for (const m of mutations) {
        // Wenn neue Knoten mit Preisinhalten hinzukommen
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return; // nur Elemente
          // Direkt markante Container prüfen oder deren Nachkommen
          if (
            node.matches?.('[data-gross-price], .price, recently-viewed, product-card, .products-grid-container')
            || node.querySelector?.('[data-gross-price], .price')
          ) {
            needsApply = true;
          }
        });

        // Optional: wenn Text in Preisbereichen geändert wurde
        if (m.type === 'characterData') {
          const el = m.target?.parentElement;
          if (el && (el.closest?.('.price') || el.matches?.('[data-net-price]'))) {
            needsApply = true;
          }
        }
      }

      if (needsApply) {
        window.ShopTaxConfig.applyGrossPrices(document);
      }
    });

    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
})();
